/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetDiscountByIdDto } from '../models/custom-result-of-get-discount-by-id-dto';
import { CustomResultOfPaginatedListOfGetDiscountsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-discounts-with-pagination-dto';
import { CustomResultOfVerifyDiscountDto } from '../models/custom-result-of-verify-discount-dto';
import { discountCreateGet } from '../fn/discount/discount-create-get';
import { DiscountCreateGet$Params } from '../fn/discount/discount-create-get';
import { discountCreatePost } from '../fn/discount/discount-create-post';
import { DiscountCreatePost$Params } from '../fn/discount/discount-create-post';
import { discountDelete } from '../fn/discount/discount-delete';
import { DiscountDelete$Params } from '../fn/discount/discount-delete';
import { discountGetDiscountsAuditWithPagination } from '../fn/discount/discount-get-discounts-audit-with-pagination';
import { DiscountGetDiscountsAuditWithPagination$Params } from '../fn/discount/discount-get-discounts-audit-with-pagination';
import { discountGetDiscountsWithPagination } from '../fn/discount/discount-get-discounts-with-pagination';
import { DiscountGetDiscountsWithPagination$Params } from '../fn/discount/discount-get-discounts-with-pagination';
import { discountGetDiscountUseAuditsWithPagination } from '../fn/discount/discount-get-discount-use-audits-with-pagination';
import { DiscountGetDiscountUseAuditsWithPagination$Params } from '../fn/discount/discount-get-discount-use-audits-with-pagination';
import { discountUpdateGet } from '../fn/discount/discount-update-get';
import { DiscountUpdateGet$Params } from '../fn/discount/discount-update-get';
import { discountUpdatePut } from '../fn/discount/discount-update-put';
import { DiscountUpdatePut$Params } from '../fn/discount/discount-update-put';
import { discountVerifyDiscount } from '../fn/discount/discount-verify-discount';
import { DiscountVerifyDiscount$Params } from '../fn/discount/discount-verify-discount';

@Injectable({ providedIn: 'root' })
export class DiscountService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `discountCreateGet()` */
  static readonly DiscountCreateGetPath = '/Discount/Create';

  /**
   * ایجاد(بررسی دسترسی).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `discountCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  discountCreateGet$Response(params?: DiscountCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return discountCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد(بررسی دسترسی).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `discountCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  discountCreateGet(params?: DiscountCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.discountCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `discountCreatePost()` */
  static readonly DiscountCreatePostPath = '/Discount/Create';

  /**
   * ایجاد.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `discountCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountCreatePost$Response(params: DiscountCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return discountCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `discountCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountCreatePost(params: DiscountCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.discountCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `discountUpdateGet()` */
  static readonly DiscountUpdateGetPath = '/Discount/Update';

  /**
   * دریافت بر اساس شناسه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `discountUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  discountUpdateGet$Response(params?: DiscountUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetDiscountByIdDto>> {
    return discountUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت بر اساس شناسه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `discountUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  discountUpdateGet(params?: DiscountUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetDiscountByIdDto> {
    return this.discountUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetDiscountByIdDto>): CustomResultOfGetDiscountByIdDto => r.body)
    );
  }

  /** Path part for operation `discountUpdatePut()` */
  static readonly DiscountUpdatePutPath = '/Discount/Update';

  /**
   * ویرایش.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `discountUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountUpdatePut$Response(params: DiscountUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return discountUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `discountUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountUpdatePut(params: DiscountUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.discountUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `discountDelete()` */
  static readonly DiscountDeletePath = '/Discount/Delete';

  /**
   * حذف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `discountDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountDelete$Response(params: DiscountDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return discountDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `discountDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountDelete(params: DiscountDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.discountDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `discountGetDiscountsWithPagination()` */
  static readonly DiscountGetDiscountsWithPaginationPath = '/Discount/GetDiscountsWithPagination';

  /**
   * دریافت با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `discountGetDiscountsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountGetDiscountsWithPagination$Response(params: DiscountGetDiscountsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetDiscountsWithPaginationDto>> {
    return discountGetDiscountsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `discountGetDiscountsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountGetDiscountsWithPagination(params: DiscountGetDiscountsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetDiscountsWithPaginationDto> {
    return this.discountGetDiscountsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetDiscountsWithPaginationDto>): CustomResultOfPaginatedListOfGetDiscountsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `discountVerifyDiscount()` */
  static readonly DiscountVerifyDiscountPath = '/Discount/VerifyDiscount';

  /**
   * کد تخفیف و نوعش و مبلغ را میده، میگه تخفیف درسته یا نه و از مبلغ کم میکنه و بر میگردونه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `discountVerifyDiscount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountVerifyDiscount$Response(params: DiscountVerifyDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfVerifyDiscountDto>> {
    return discountVerifyDiscount(this.http, this.rootUrl, params, context);
  }

  /**
   * کد تخفیف و نوعش و مبلغ را میده، میگه تخفیف درسته یا نه و از مبلغ کم میکنه و بر میگردونه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `discountVerifyDiscount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountVerifyDiscount(params: DiscountVerifyDiscount$Params, context?: HttpContext): Observable<CustomResultOfVerifyDiscountDto> {
    return this.discountVerifyDiscount$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfVerifyDiscountDto>): CustomResultOfVerifyDiscountDto => r.body)
    );
  }

  /** Path part for operation `discountGetDiscountsAuditWithPagination()` */
  static readonly DiscountGetDiscountsAuditWithPaginationPath = '/Discount/GetDiscountsAuditWithPagination';

  /**
   * دریافت گزارش Audit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `discountGetDiscountsAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountGetDiscountsAuditWithPagination$Response(params: DiscountGetDiscountsAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return discountGetDiscountsAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت گزارش Audit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `discountGetDiscountsAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountGetDiscountsAuditWithPagination(params: DiscountGetDiscountsAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.discountGetDiscountsAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `discountGetDiscountUseAuditsWithPagination()` */
  static readonly DiscountGetDiscountUseAuditsWithPaginationPath = '/Discount/GetDiscountUseAuditsWithPagination';

  /**
   * دریافت گزارش DiscountUse, تخفیف کجا ها استفاده شده.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `discountGetDiscountUseAuditsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountGetDiscountUseAuditsWithPagination$Response(params: DiscountGetDiscountUseAuditsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return discountGetDiscountUseAuditsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت گزارش DiscountUse, تخفیف کجا ها استفاده شده.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `discountGetDiscountUseAuditsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  discountGetDiscountUseAuditsWithPagination(params: DiscountGetDiscountUseAuditsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.discountGetDiscountUseAuditsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
